// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IModelResponse, IModel } from '@cian/http-api';
import type { IMyHomeListV2ResponseSchema } from '../../../entities/card/MyHomeListV2ResponseSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export interface IPublicMyHomeV1GetRealtyListRequest {
  myHomeTypes?: EMyHomeTypes[];
}
export enum EMyHomeTypes {
  /** Новостройка **/
  'Newbuilding' = 'newbuilding',
  /** Вторичка **/
  'Secondary' = 'secondary',
  /** Загородная недвижимость **/
  'Suburban' = 'suburban',
}

export type IPublicMyHomeV1GetRealtyListResponse = IMyHomeListV2ResponseSchema;

export interface IPublicMyHomeV1GetRealtyListResponse200 extends IModelResponse<IPublicMyHomeV1GetRealtyListResponse> {
  statusCode: 200;
}

export type IPublicMyHomeV1GetRealtyListResponseError = IErrorResponseSchema;

export interface IPublicMyHomeV1GetRealtyListResponse400
  extends IModelResponse<IPublicMyHomeV1GetRealtyListResponseError> {
  statusCode: 400;
}

export type TPublicMyHomeV1GetRealtyListResponse =
  | IPublicMyHomeV1GetRealtyListResponse200
  | IPublicMyHomeV1GetRealtyListResponse400;

export type TPublicMyHomeV1GetRealtyListModel = IModel<
  IPublicMyHomeV1GetRealtyListRequest,
  TPublicMyHomeV1GetRealtyListResponse
>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IPublicMyHomeV1GetRealtyListResponse): TResponse200;
  400(response: IPublicMyHomeV1GetRealtyListResponseError): TResponse400;
}
